import { HttpClient } from '../http-client';
class TaskApprovalHttpClient extends HttpClient {
    async getApprovalList(projectId, taskId) {
        return this.get(`/projects/${projectId}/tasks/${taskId}/approvals`);
    }
    async getApproval(projectId, type, dates) {
        return this.get(`/projects/${projectId}/approvals?filterType=${type}&startDate=${dates[0]}&endDate=${dates[1]}`);
    }
    async updateApproval(projectId, taskId, approvalId, payload) {
        return this.put(`projects/${projectId}/tasks/${taskId}/approvals/${approvalId}`, payload);
    }
    async createApproval(projectId, taskId, payload) {
        return this.post(`projects/${projectId}/tasks/${taskId}/approvals`, payload);
    }
    async deleteApproval(projectId, taskId, approvalId) {
        return this.delete(`projects/${projectId}/tasks/${taskId}/approvals/${approvalId}`);
    }
    async getApprovals({ projectId, taskId }) {
        return this.get(`projects/${projectId}/tasks/${taskId}/approvals`);
    }
}
export const TaskApprovalAPI = new TaskApprovalHttpClient();
